module.exports = __webpack_public_path__ + "static/img/research_apper.e18df847.webp";